// Generated from RelatedRoute's `required_filter_groups` — do not edit.

import type {FilterDefinitionMapping} from '../../boot/hooks/useApi'
import type {Iri} from '../Api'

export type RelatedRouteCollectionFilterGroups
  = | {
    readonly route: Iri
  }

export const relatedRouteCollectionFilterMapping: FilterDefinitionMapping<RelatedRouteCollectionFilterGroups> = {
  route: 'route',
}

export type RelatedRouteCollectionSort = never
